<template>
  <div class="early-bird-client-details" :gutter="18">
    <el-col :span="22" :offset="1">
      <el-form ref="clientForm" :model="form" :rules="rules" label-width="125px">
        <h4 class="text-uppercased">Primary Taxpayer</h4>
        <el-row :gutter="18">
          <el-col :span="12">
            <el-form-item label="First Name" prop="firstName">
              <el-input v-model="clientVm.firstName" placeholder="First Name"></el-input>
            </el-form-item>
            <el-form-item label="Last Name" prop="lastName">
              <el-input v-model="clientVm.lastName" placeholder="Last Name"></el-input>
            </el-form-item>
            <el-form-item label="SSN" prop="ssn">
              <masked-el-input v-model="clientVm.ssn" :mask="'###-##-####'" placeholder="Social Security Number"></masked-el-input>
            </el-form-item>
            <el-form-item label="Confirm SSN" prop="confirmSSN" v-if="!clientVm.id">
              <masked-el-input v-model="clientForm.confirmSSN" :mask="'###-##-####'" placeholder="Confirm SSN"></masked-el-input>
            </el-form-item>
            <el-form-item label="Driver's License" prop="driversLicense">
              <el-input v-model="clientVm.stateId" placeholder="Driver's License"></el-input>
            </el-form-item>
            <el-form-item label="Confirm DL" prop="confirmDriversLicense" v-if="!clientVm.id">
              <el-input v-model="clientForm.confirmDriversLicense" placeholder="Confirm Driver's License"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="City" prop="city">
              <el-input v-model="clientVm.city" placeholder="City"></el-input>
            </el-form-item>
            <el-form-item label="State" prop="state">
              <us-state-select v-model="clientVm.state"></us-state-select>
            </el-form-item>
            <el-form-item label="Zipcode" prop="zip">
              <el-input v-model="clientVm.zip" placeholder="Zipcode"></el-input>
            </el-form-item>
            <el-form-item label="Email Address" prop="email">
              <el-input v-model="clientVm.email" placeholder="Email Address"></el-input>
            </el-form-item>
            <el-form-item label="Phone" prop="phone">
              <el-input v-model="clientVm.phone" placeholder="Phone"></el-input>
            </el-form-item>
            <el-form-item label="Receive Text Messages" label-width="200px">
              <el-radio-group v-model="clientVm.text_optin">
                <el-radio :label="true">Yes</el-radio>
                <el-radio :label="false">No</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="!this.spouseVm.id">
          <h4 class="text-uppercased">
            <el-form-item label="Filing with Spouse?" prop="filingWithSpouse" label-width="200px">
              <el-radio-group v-model="clientForm.filingWithSpouse">
                <el-radio :label="true">Yes</el-radio>
                <el-radio :label="false">No</el-radio>
              </el-radio-group>
            </el-form-item>
          </h4>
        </el-row>
      </el-form>
      <el-form ref="spouseForm" :model="spousesForm" :rules="rules" label-width="125px">
        <h4 class="text-uppercased">Taxpayer Spouse</h4>
        <el-row :gutter="18">
          <el-col :span="12">
            <el-form-item label="First Name" prop="firstName">
              <el-input v-model="spouseVm.firstName" placeholder="Spouse First Name" :disabled="disableSpouseForm"></el-input>
            </el-form-item>
            <el-form-item label="Last Name" prop="lastName">
              <el-input v-model="spouseVm.lastName" placeholder="Spouse Last Name" :disabled="disableSpouseForm"></el-input>
            </el-form-item>
            <el-form-item label="SSN" prop="ssn">
              <masked-el-input v-model="spouseVm.ssn" :mask="'###-##-####'" placeholder="Spouse Social Security Number" :disabled="disableSpouseForm"></masked-el-input>
            </el-form-item>
            <el-form-item label="Confirm SSN" prop="confirmSpouseSSN" v-if="!spouseVm.id">
              <masked-el-input v-model="spouseForm.confirmSSN" :mask="'###-##-####'" placeholder="Confirm Spouse SSN" :disabled="disableSpouseForm"></masked-el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Driver's License" prop="spouseDriversLicense">
              <el-input v-model="spouseVm.stateId" placeholder="Spouse Driver's License" :disabled="disableSpouseForm"></el-input>
            </el-form-item>
            <el-form-item label="Email Address" prop="email">
              <el-input v-model="spouseVm.email" placeholder="Spouse Email Address" :disabled="disableSpouseForm"></el-input>
            </el-form-item>
            <el-form-item label="Phone" prop="phone">
              <el-input v-model="spouseVm.phone" placeholder="Spouse Phone" :disabled="disableSpouseForm"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-col>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import get from 'lodash/get';
import { Required, SSN, GenericDoubleBlindValidation } from '@/util/formValidators';
import MaskedElInput from '@/components/form-item/MaskedElInput.vue';
import UsStateSelect from '@/components/form-item/USStateSelect.vue';
import { Client, Spouse } from '@/model';

export default {
  name: 'eb-client-details',
  data() {
    return {
      clientVm: new Client(),
      spouseVm: new Spouse(),
      clientForm: {
        confirmDriversLicense: undefined,
        confirmSSN: undefined,
        filingWithSpouse: this.spouse !== undefined && this.spouse.id > 0,
      },
      spouseForm: {
        confirmSSN: undefined,
      },
      // when the spouse form is reset, it's state is stored here so it can be recovered
      spouseReservedState: {},
      rules: {
        ssn: [Required, SSN],
        confirmSSN: [Required, SSN, { validator: this.mustMatch('form.ssn'), trigger: 'blur' }],
        confirmSpouseSSN: [Required, SSN, { validator: this.mustMatch('spousesForm.ssn'), trigger: 'blur' }],
        driversLicense: [Required],
        confirmDriversLicense: [Required, { validator: this.mustMatch('form.driversLicense'), trigger: 'blur' }],
        firstName: [Required],
        lastName: [Required],
        filingWithSpouse: [Required],
      },
    };
  },
  methods: {
    ...mapActions('Client', [
      'setClient',
    ]),
    ...mapActions('Client', {
      saveClient: 'save',
    }),
    mustMatch(formItem) {
      return (...args) => {
        GenericDoubleBlindValidation(get(this, formItem), ...args);
      };
    },
    async save() {
      let formsAreValid = false;
      await this.$refs.clientForm.validate(async (valid) => {
        if (valid) {
          if (!this.disableSpouseForm) {
            this.$refs.spouseForm.validate((spouseIsValid) => {
              if (spouseIsValid) {
                formsAreValid = true;
              }
            });
          } else {
            formsAreValid = true;
          }
        }
      });

      if (formsAreValid) {
        try {
          if (this.clientForm.filingWithSpouse || (this.spouse && this.spouse.id)) {
            this.clientVm.spouse = new Spouse(this.spouseVm);
          } else {
            this.clientVm.spouse = undefined;
          }
          await this.setClient(new Client(this.clientVm));
          await this.saveClient();
        } catch (e) {
          throw e;
        }
      } else {
        throw new Error('Forms are not valid');
      }
    },
  },
  computed: {
    ...mapGetters('Client', [
      'client',
      'spouse',
    ]),
    form() {
      return {
        ssn: this.clientVm.ssn,
        confirmSSN: this.clientForm.confirmSSN,
        driversLicense: this.clientVm.stateId,
        confirmDriversLicense: this.clientForm.confirmDriversLicense,
        firstName: this.clientVm.firstName,
        lastName: this.clientVm.lastName,
        city: this.clientVm.city,
        state: this.clientVm.state,
        zip: this.clientVm.zip,
        email: this.clientVm.email,
        phone: this.clientVm.phone,
        filingWithSpouse: this.clientForm.filingWithSpouse,
        textOptin: this.clientVm.text_optin,
      };
    },
    spousesForm() {
      return {
        id: this.spouseVm.id,
        ssn: this.spouseVm.ssn,
        confirmSpouseSSN: this.spouseForm.confirmSSN,
        driversLicense: this.spouseVm.stateId,
        firstName: this.spouseVm.firstName,
        lastName: this.spouseVm.lastName,
        email: this.spouseVm.email,
        phone: this.spouseVm.phone,
      };
    },
    disableSpouseForm() {
      return !this.form.filingWithSpouse && !(this.spouse && this.spouse.id);
    },
  },
  watch: {
    client: {
      immediate: true,
      handler(val) {
        this.clientVm = new Client(val);
      },
    },
    spouse: {
      immediate: true,
      handler(val) {
        this.spouseVm = new Spouse(val);
      },
    },
    'form.filingWithSpouse': function onFilingWithSpouseChange(isFilingWithSpouse) {
      if (!isFilingWithSpouse) {
        this.spouseReservedState = { ...this.spouseForm };
        this.clientVm.spouse = undefined;

        this.spouseVm = new Spouse();

        this.$refs.spouseForm.resetFields();
      } else {
        this.spouseVm = new Spouse(this.spouseReservedState);
      }
    },
  },
  components: {
    MaskedElInput,
    UsStateSelect,
  },
};

</script>
